(function () {
  "use strict";
  if (window.__exosLB) return;
  window.__exosLB = 1;

  var css =
    ".exos-lb{position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.9);padding:16px;}" +
    ".exos-lb.is-open{display:flex;}" +
    ".exos-lb__img{max-width:92vw;max-height:92vh;width:auto;height:auto;object-fit:contain;user-select:none;-webkit-user-select:none;}" +
    ".exos-lb__btn{position:fixed;background:rgba(0,0,0,.35);border:0;color:#fff;cursor:pointer;z-index:100000;line-height:1;}" +
    ".exos-lb__btn:hover{background:rgba(0,0,0,.6);}" +
    ".exos-lb__close{top:12px;right:16px;font-size:32px;padding:2px 12px;border-radius:6px;}" +
    ".exos-lb__nav{top:50%;transform:translateY(-50%);font-size:30px;padding:8px 16px;border-radius:8px;}" +
    ".exos-lb__prev{left:10px;}" +
    ".exos-lb__next{right:10px;}" +
    ".exos-lb--single .exos-lb__nav{display:none;}" +
    "[data-product-single-media-slider] img[data-product-image]{cursor:zoom-in;}";

  // Build a clean, proportional Shopify image URL (width only — strips crop/height
  // so landscape/portrait images are never cropped).
  function sized(rawSrc, w) {
    if (!rawSrc) return rawSrc;
    var base = rawSrc.split("?")[0];
    var qi = rawSrc.indexOf("?");
    var q = qi >= 0 ? rawSrc.slice(qi + 1) : "";
    var m = q.match(/(?:^|&)v=([^&]*)/);
    return base + "?width=" + w + (m ? "&v=" + m[1] : "");
  }

  function build() {
    if (document.querySelector(".exos-lb")) return;
    var st = document.createElement("style");
    st.textContent = css;
    document.head.appendChild(st);

    var ov = document.createElement("div");
    ov.className = "exos-lb";
    ov.setAttribute("aria-hidden", "true");
    ov.innerHTML =
      '<button type="button" class="exos-lb__btn exos-lb__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="exos-lb__btn exos-lb__nav exos-lb__prev" aria-label="Previous image">&#8249;</button>' +
      '<button type="button" class="exos-lb__btn exos-lb__nav exos-lb__next" aria-label="Next image">&#8250;</button>' +
      '<img class="exos-lb__img" alt="">';
    document.body.appendChild(ov);

    var img = ov.querySelector(".exos-lb__img");
    var items = [];
    var idx = 0;

    function keyOf(el) {
      return el.getAttribute("data-image-id") || el.currentSrc || el.src;
    }

    function collect() {
      items = [];
      var seen = {};
      var slider = document.querySelector("[data-product-single-media-slider]");
      if (!slider) return;
      var imgs = slider.querySelectorAll("img[data-product-image]");
      for (var i = 0; i < imgs.length; i++) {
        var im = imgs[i];
        var id = keyOf(im);
        if (seen[id]) continue;
        seen[id] = 1;
        // shown = the already-loaded proportional srcset image (instant, cached).
        // big   = clean proportional 1600px (sharp, never cropped).
        items.push({
          id: id,
          shown: im.currentSrc || "",
          big: sized(im.getAttribute("src") || im.currentSrc, 1600),
          alt: im.alt || ""
        });
      }
    }

    function preload(i) {
      if (items.length < 2) return;
      var it = items[(i + items.length) % items.length];
      if (it) new Image().src = it.big;
    }
    function show(i) {
      if (!items.length) return;
      idx = (i + items.length) % items.length;
      var it = items[idx];
      img.alt = it.alt;
      img.src = it.shown || it.big; // instant if cached, else the clean big one
      if (it.shown && it.shown !== it.big) {
        var pre = new Image();
        pre.onload = function () {
          if (items[idx] === it) img.src = it.big;
        };
        pre.src = it.big;
      }
      preload(idx + 1);
      preload(idx - 1);
    }
    function next() { show(idx + 1); }
    function prev() { show(idx - 1); }

    function openFrom(el) {
      collect();
      ov.classList.toggle("exos-lb--single", items.length <= 1);
      var k = keyOf(el), start = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].id === k) { start = i; break; }
      }
      show(start);
      ov.classList.add("is-open");
      ov.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
    }
    function close() {
      ov.classList.remove("is-open");
      ov.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      img.removeAttribute("src");
    }

    document.addEventListener(
      "click",
      function (e) {
        if (!e.target.closest("[data-product-single-media-slider]")) return;
        var slide = e.target.closest(".product-gallery__media-slide");
        var t = slide
          ? slide.querySelector("img[data-product-image]")
          : e.target.closest("img[data-product-image]");
        if (t) {
          e.preventDefault();
          openFrom(t);
        }
      },
      true
    );

    ov.addEventListener("click", function (e) {
      if (e.target === ov) close();
    });
    ov.querySelector(".exos-lb__close").addEventListener("click", close);
    ov.querySelector(".exos-lb__prev").addEventListener("click", prev);
    ov.querySelector(".exos-lb__next").addEventListener("click", next);

    document.addEventListener("keydown", function (e) {
      if (!ov.classList.contains("is-open")) return;
      if (e.key === "Escape" || e.key === "Esc") close();
      else if (e.key === "ArrowRight") next();
      else if (e.key === "ArrowLeft") prev();
    });

    var tx = null;
    ov.addEventListener(
      "touchstart",
      function (e) {
        tx = e.touches.length === 1 ? e.touches[0].clientX : null;
      },
      { passive: true }
    );
    ov.addEventListener(
      "touchend",
      function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx;
        tx = null;
        if (Math.abs(dx) > 50) {
          if (dx < 0) next();
          else prev();
        }
      },
      { passive: true }
    );
  }

  if (document.body) build();
  else document.addEventListener("DOMContentLoaded", build);
})();
